import { render, staticRenderFns } from "./PropertyBrand.vue?vue&type=template&id=d7d3c210&scoped=true"
import script from "./PropertyBrand.vue?vue&type=script&lang=js"
export * from "./PropertyBrand.vue?vue&type=script&lang=js"
import style0 from "./PropertyBrand.vue?vue&type=style&index=0&id=d7d3c210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d3c210",
  null
  
)

export default component.exports